import EssentialAppLearnMoreDialog from '@/components/app-bundle-learn-more-dialog.vue';
import AICompanionLearnMoreDialog from '@/components/full-comparison-table/ai-companion-learn-more-dialog.vue';
import CustomAvatarLearnMoreDialog from '@/components/full-comparison-table/custom-avatar-learn-more-dialog.vue';
import { ServiceConfirm } from '@/components/common/service-dialog/confirm';
import { unlockBizLicenseCount, unlockBizMaxLicenseCount } from '@/common/constants';

export default {
	computed:{
    comparisonProps() {
      const EssentialAPPCallback = this.openEssential
      const VisitorManagementCallback = this.openVisitManagement
      const AICompanionCallBack = this.openAICompanion
      const CustomAvatarCallback = this.openCustomAvatar
      const currentCountry = this.currentCountry
      const freeZoomClipsQuantity = this.freeZoomClipsQuantity
      return {
        unlockBizLicenseCount,
        unlockBizMaxLicenseCount,
        EssentialAPPCallback,
        VisitorManagementCallback,
        AICompanionCallBack,
        currentCountry,
        freeZoomClipsQuantity,
        largeMeetingConfig: this.lmConfig,
				enableDocsFeature: window.newBillingConfig.enableDocsFeature,
        enableDisplayZoomTasksWithoutAccountCheck: window.newBillingConfig.enableDisplayZoomTasksWithoutAccountCheck,
        showCustomAvatarLearnMore: false /* CUSTOM_AVATAR TODO: disabled it for temp in 2025 April release */,
        isEligibleAccount4CustomAvatarFeature: window.newBillingConfig.isEligibleAccount4CustomAvatarFeature,
        enableDisplayZoomWorkFlow: window.newBillingConfig.enableDisplayZoomWorkFlow,
        enableDisplayZoomDrive: window.newBillingConfig.enableDisplayZoomDrive,
        CustomAvatarCallback
      }
    },
		currentCountry(){
			return window.newBillingConfig.currentCountry || 'US'
		},
		freeZoomClipsQuantity(){
			return window.newBillingConfig.freeZoomClipsQuantity || '5'
		},
    lmConfig() {
      const { pro, proPlus, business, businessPlus } = this.largeMeetingConfig || {};

      return {
        pro: this.rewriteLargeConfig(pro),
        proPlus: this.rewriteLargeConfig(proPlus),
        business: this.rewriteLargeConfig(business),
        businessPlus: this.rewriteLargeConfig(businessPlus),
      }
    }
	},
	data(){
		return{
			essentialAppLearnMoreDialogService: new ServiceConfirm(EssentialAppLearnMoreDialog),
			aiCompanionLearnMoreDialogService: new ServiceConfirm(AICompanionLearnMoreDialog),
      customAvatarLearnMoreDialogService: new ServiceConfirm(CustomAvatarLearnMoreDialog),
		}
	},
  methods: {
    openCustomAvatar() {
      this.customAvatarLearnMoreDialogService.confirm()
    },
    openEssential() {
      this.essentialAppLearnMoreDialogService.confirm()
    },
    openVisitManagement() {
      this.visitorManagementLearnMoreDialogService.confirm()
    },
    openAICompanion() {
      this.aiCompanionLearnMoreDialogService.confirm()
    },
    rewriteLargeConfig(config) {
      if (typeof config?.callback === 'function') {
        const cb = () => {
          config.callback();
          this.handleCancel();
        };
        return {
          ...config,
          callback: cb,
        };
      }
      return config;
    }
  }
};
